import { render, staticRenderFns } from "./lstCourse.vue?vue&type=template&id=e47f88c8&"
import script from "./lstCourse.vue?vue&type=script&lang=js&"
export * from "./lstCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports